import { Methods } from '@doda/api-client/aspida/api/v1/jobs';
import {
  JobListResponse as JobListV1Response,
  JobListV2Response,
} from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';
import { IncomingHttpHeaders } from 'http';
import { getAccessToken } from './getAccessToken';

type V1Query = Methods['get']['query'];

interface Props {
  query?: V1Query;
  headers?: IncomingHttpHeaders;
  useV2JobSearchListApi: boolean;
}

/**
 * getJobSearchList
 * @param 0
 * @returns
 */
export const getJobSearchList = async ({
  query,
  headers,
  useV2JobSearchListApi,
}: Props) => {
  if (!useV2JobSearchListApi) {
    return apiClient.api.v1.jobs.$get({
      query,
      config: { headers },
    });
  }

  // ログイン状態を問わず呼び出し、ログイン中の場合のみアクセストークンを取得する。
  // (ローカル環境で起動した場合、クライアントから呼び出すと未ログイン扱いになる)。
  const accessToken = await getAccessToken(headers);
  const v2Response = await apiClient.api.v2.jobs.$get({
    query,
    config: {
      headers: {
        ...headers,
        ...(accessToken && { authorization: `Bearer ${accessToken}` }),
      },
    },
  });
  return toV1Response(v2Response);
};

const toV1Response = (v2Response: JobListV2Response): JobListV1Response => {
  // 既存API (solr) ではseminarIdがnullの場合に'0'として返却していた。
  // 新規APIではnullとして返却されるが、既存APIと整合性を合わせるため'0'に変換する。
  // TODO: 新規APIに統一するタイミングで、nullとして扱っても問題ないか確認したうえで当該変換処理を削除すること。
  return {
    metaData: v2Response.metaData,
    results: v2Response.results?.map((result) => ({
      ...result,
      seminarId: result.seminarId ?? '0',
    })),
  };
};
